module.exports = __webpack_public_path__ + "static/media/sbf-vc-hostile-press.37c8187d.png";